import type { TimezoneName } from "./dateTypes.js";

export const OUTPUTS_DOMAIN_NAME_ATTRIBUTE = "data-outputs-domain-name";

export const MAX_KERNEL_TIMEOUT_MILLIS = 7 * 24 * 60 * 60 * 1000; // 1 week

export const MAX_FILE_COUNT = 100;

export const MAX_TAO_CHART_INPUT_LENGTH = 100_000;
export const MAX_TAO_CREATION_NAME_ATTEMPTS = 1_000;
export const MAX_TAO_CREATION_COLUMNS = 100;
export const MAX_TAO_INPUT_OPTIONS = 1_000;
export const MAX_TAO_INPUT_PARAMETERS = 1_000;
export const MAX_TAO_CONTROL_TEXT_LENGTH = 1_000;
export const MAX_TAO_SQL_PROBE_ROWS = 50;
export const MAX_TAO_SQL_PROBE_SQL_BYTES = 64 * 1024;
// Code project tool previews are stored on the agent thread, so each is bounded.
export const MAX_TAO_PREVIEW_ROWS = 10;
export const MAX_TAO_PREVIEW_COLUMNS = 20;
export const MAX_TAO_PREVIEW_CELL_CHARS = 300;
export const MAX_TAO_PREVIEW_TEXT_CHARS = 2_000;
export const MAX_TAO_PREVIEWED_ARTIFACTS = 10;
/** Later cells are counted instead of shown once a run's previews pass this. */
export const MAX_TAO_PREVIEW_TOTAL_CHARS = 50_000;
export const MAX_TAO_PREVIEWED_DAG_NAMES = 50;

export const MAX_TAO_MCP_FILE_BYTES = 5 * 1024 * 1024;
export const MAX_TAO_MCP_FILE_READ_LINES = 2_000;
export const MAX_TAO_MCP_PATH_LENGTH = 2048;
export const MAX_TAO_MCP_ARTIFACTS_PER_EVALUATION = 20;
export const MAX_TAO_MCP_ARTIFACT_NAME_LENGTH = 1024;
export const MAX_TAO_MCP_PARAMETER_BYTES = 64 * 1024;
export const MAX_DAG_AGENT_PREVIEW_ROWS = 20;
export const MAX_DAG_AGENT_ARTIFACT_PREVIEW_BYTES = 1024 * 1024;
export const MAX_TAO_CODE_API_ARTIFACT_READ_BYTES = 10 * 1024 * 1024;
export const MAX_TAO_MCP_PREVIEW_BYTES = 1024 * 1024;
// Must not exceed the Hub's `MAX_PROJECTS` in hexdag/crates/language-semantic/src/projects.rs.
export const MAX_SEMANTIC_PROJECT_TAO_PROJECT_REF_LINKS = 64;

export const MAX_EDIT_TAO_PROJECT_USER_GRANTS = 25;
export const MAX_EDIT_TAO_PROJECT_GROUP_GRANTS = 25;
export const MAX_ADMIN_ACCESS_REASON_LENGTH = 150;
export const MAX_BATCH_UPDATE_PROJECTS_SIZE = 250;
export const MAX_BATCH_UPDATE_PROJECT_RELATIONSHIP_IDS_SIZE = 20;

export const TRASHED_FOLDER_ENTITY_LIFETIME_IN_DAYS = 30;

export const DATA_FRAME_SQL_CONNECTION_ID = "dataFrameCell";
export type DATA_FRAME_SQL_CONNECTION_ID = typeof DATA_FRAME_SQL_CONNECTION_ID;

export const MULTISELECT_SELECT_ALL_OPTION =
  "__hex_multiselect_select_all_option__";

export const DEFAULT_FONT_FAMILY = `"IBM Plex Sans", system-ui, -apple-system, BlinkMacSystemFont, sans-serif`;

export const UTC = "UTC" as TimezoneName;
export const DEFAULT_TIMEZONE = UTC;

export const HEX_SECURE_VALUE_DUMMY_VALUE = "$$hexdummyvalue$$";

// used for S3 integration where we have field validation on 40 char length
export const HEX_SECURE_VALUE_DUMMY_VALUE_40_CHAR =
  "$$$$$$$$$$$$$$$hexdummyvalue$$$$$$$$$$$$";

export const EXPLORE_LIFETIME_IN_DAYS = 14;

export const GOOGLE_SHEETS_DEFAULT_TAB_NAME = "Sheet1";

export const TITLE_MAX_LENGTH = 500;
export const DEFAULT_PROJECT_TITLE = "Untitled project";
export const DEFAULT_COMPONENT_TITLE = "Untitled component";
export const DEFAULT_THREAD_TITLE = "New thread";

export const isDefaultProjectTitle = (title: string): boolean =>
  title.startsWith(DEFAULT_PROJECT_TITLE);

export const isDefaultComponentTitle = (title: string): boolean =>
  title.startsWith(DEFAULT_COMPONENT_TITLE);

export const isDefaultThreadTitle = (title: string): boolean =>
  title.startsWith(DEFAULT_THREAD_TITLE);

export const DEFAULT_TASK_EXPIRATION_DAYS = 90;
export const DEFAULT_TASK_EXPIRATION_HOUR = 23;
export const DEFAULT_TASK_EXPIRATION_MINUTE = 55;

export const INITIAL_OAUTH_TOKEN_EXPIRATION_NOTIFICATION_HOURS = 72;
export const FINAL_OAUTH_TOKEN_EXPIRATION_NOTIFICATION_HOURS = 24;
